class SubmenuLinks {

  constructor() {
    this.initializeSubmenuLinks();
  }

  initializeSubmenuLinks() {
    const submenuLinks = document.querySelectorAll('.submenu .submenu-options-mobile select');
    const submenuLinksDesktop = document.querySelectorAll('.submenu .submenu-options-desktop select');

    submenuLinks.forEach((item) => {
      item.addEventListener('change', (e) => {
        var selectedOption = item[item.selectedIndex];
        document.location.href = selectedOption.value;
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SubmenuLinks();
})
